import React from "react";
import { Card } from "@sscs/ui";
import { prettifyLargeCount } from "@sscs/utils";
import { NO_PREVALENCE_TEXT } from "../utils";
import styles from "./maliciousness.module.scss";
const Maliciousness = ({ maliciousness, total, fullWidth, }) => {
    const title = (React.createElement("div", { className: styles.title }, "Prevalence in Spectra Intelligence"));
    if (maliciousness === null || total === null)
        return (React.createElement(Card.Card, { fullWidth: fullWidth },
            React.createElement(Card.Title, null, title),
            React.createElement(Card.Content, null, NO_PREVALENCE_TEXT)));
    return (React.createElement(Card.Card, { fullWidth: fullWidth },
        React.createElement(Card.Title, null, title),
        React.createElement(Card.Content, { className: styles["content"] },
            React.createElement("div", { className: styles["card"] },
                React.createElement("div", { className: styles["cell"] },
                    maliciousness,
                    "%"),
                React.createElement("div", { className: styles["cell"] },
                    "of ",
                    prettifyLargeCount(total),
                    " Samples")),
            React.createElement("div", null, maliciousness
                ? "Some malware samples in Spectra Intelligence exhibit this behavior"
                : "No malware samples in Spectra Intelligence exhibit this behavior"))));
};
export default Maliciousness;
//# sourceMappingURL=Maliciousness.js.map